// Define the core values measured in the Test Latino™
export const VALUES = [
  'authority',           // Leadership and organizational structure
  'communication',       // Professional communication
  'cultural_pride',      // Cultural identity and heritage
  'family',             // Family and work-life integration
  'group_loyalty',      // Team commitment
  'growth',             // Professional development
  'humility',           // Professional modesty
  'respect',            // Professional relationships
  'sacrifice',          // Dedication and commitment
  'tenacity_drive'      // Determination and motivation
] as const;

// Type for the values
export type ValueDomain = typeof VALUES[number];

// Descriptions for each value
export const VALUE_DESCRIPTIONS: Record<ValueDomain, string> = {
  authority: 'Understanding and navigating hierarchical structures appropriately',
  communication: 'Effective and culturally appropriate professional communication',
  cultural_pride: 'Embracing and leveraging cultural background as a professional strength',
  family: 'Prioritizing family needs and maintaining strong family bonds in career decisions',
  group_loyalty: 'Demonstrating loyalty and commitment to team success',
  growth: 'Commitment to continuous learning and professional development',
  humility: 'Maintaining modesty while achieving professional success',
  respect: 'Showing proper respect and maintaining harmonious relationships',
  sacrifice: 'Willingness to work hard and make personal sacrifices for team success',
  tenacity_drive: 'Persistent determination and motivation to achieve career goals'
};

// Questions per domain configuration
export const DOMAIN_QUESTION_COUNT: Record<ValueDomain, number> = {
  authority: 4,         // Questions 19, 20, 21, 32, 35
  communication: 4,     // Questions 16, 17, 18, 24, 31
  cultural_pride: 4,    // Questions 28, 29, 30, 34
  family: 3,           // Questions 1, 2, 3
  group_loyalty: 3,    // Questions 4, 5, 6
  growth: 5,           // Questions 25, 26, 27, 33
  humility: 3,         // Questions 7, 8, 9
  respect: 3,          // Questions 13, 14, 15
  sacrifice: 3,        // Questions 10, 11, 12
  tenacity_drive: 3    // Questions 22, 23, 35
};